import { Button, Col, Form, Input, Popconfirm, Row } from "antd";
import { useNavigate } from 'react-router-dom';

import { usersService as api } from "../../services/usersService";
import { util } from "../../utils/functions/custom";
import { Messages, Notify } from "../../services/custom/Messages";
import { recordError } from "../../utils/logService";
import { openNotification, ParagraphHeader } from "../custom";

/**
 * Used loggedin users intending to update their account password.
 * 
 * @component
 * @param {Object} props
 * @param {boolean} [props.showTitle] - Optional flag to toggle visibility of title. Defaults to invisible title.
 */
export const UserChangePassword = ({ showTitle = false }) => {

  const [form] = Form.useForm();
  const navigate = useNavigate();
  let path = `/`;

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
  };

  const cancel = () => {
    form.resetFields();
    navigate(path);
  };

  const onFinish = async (values) => {
    try {
      const { password } = values;

      const request = await api.updateUserPassword(password);

      var msg;

      if (request.status === 200 || request.status === 201) {

        form.resetFields("");
        msg = util.parseMessage(
          Messages.UPDATE_SUCCESSWITHOK,
          "User password"
        );
        openNotification("Updating Password", msg, Notify.SUCCESS);

        return;
      }

      msg = util.parseMessage(
        Messages.UPDATE_FAILURE,
        "User password"
      );
      openNotification("Updating Password", msg, Notify.ERROR);
    } catch (error) {

      openNotification(
        "Updating Password",
        "SYSTEM FAILED TO UPDATE",
        Notify.ERROR
      );
      recordError(error);

    }
  };

  const passwordRegEx = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  );
  const Passwordmessages =
    "Password must be at least 8 characters long, have 1 number,1 uppercase, and 1 special character";

  return (
    <div className="content">
      {showTitle &&
        <ParagraphHeader header="Update Password" />
      }
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
      >

        <Form.Item
          name="password"
          label="New Password"
          rules={[
            {
              required: true,
              message: Passwordmessages,
              pattern: passwordRegEx,
            },
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: Passwordmessages,
              pattern: passwordRegEx,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  !value ||
                  getFieldValue("password") === value
                ) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error(
                    "The two passwords that you entered do not match!"
                  )
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
        {/* <Form.Item> */}
        {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}

        <Row>
          <Col xs={24} className="center-align">

            <Popconfirm
              title="Are you sure you want to cancel?"
              onConfirm={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="default"
                htmlType="submit"
              >
                Cancel
              </Button>
            </Popconfirm>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginLeft: 10 }}
            >
              Submit
            </Button>
          </Col>
        </Row>

        {/* </Form.Item> */}
      </Form>
    </div>
  );
};
